const initialState = {
  mdCoverageData: [],
};

const mdCoverageSlice = (set) => ({
  ...initialState,
  setMdCoverageData: (mdCoverageData) => set({ mdCoverageData }),
  resetMdCoverageData: () => set(initialState),
});

export default mdCoverageSlice;
